import type FocusedInboxRollupStore from './schema/FocusedInboxRollupStore';
import InboxViewType from 'owa-service/lib/contract/InboxViewType';
import { createStore } from 'satcheljs';

const defaultFocusedInboxRollupStore: FocusedInboxRollupStore = {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (9,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    uniqueSenders: null,
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (13,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    unseenCountToDisplay: null,
    viewType: InboxViewType.Invalid,
};

const store = createStore<FocusedInboxRollupStore>(
    'focusedInboxRollupStore',
    defaultFocusedInboxRollupStore
)();
export default store;
